import axios from '@/utils/axiosInstance';

export interface InfoKitFile {
  _id?: string;
  domain_slug?: string;
  heading: string;
  fileUrl: string | null;
  originalFileName: string;
  fileSizeBytes: number;
  entryCount: number;
  isActive: boolean;
  downloadCount: number;
  lastDownloadedAt?: string | null;
  uploadedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getInfoKit = async (): Promise<InfoKitFile> => {
  const response = await axios.get<InfoKitFile>('/api/info-kit');
  return response.data;
};

export const updateInfoKit = async (payload: {
  heading?: string;
  isActive?: boolean;
}): Promise<InfoKitFile> => {
  const response = await axios.patch<InfoKitFile>('/api/info-kit', payload);
  return response.data;
};

export const uploadInfoKit = async (
  file: File,
  onProgress?: (percent: number) => void,
): Promise<InfoKitFile> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post<InfoKitFile>('/api/info-kit/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (event) => {
      if (event.total) {
        onProgress?.(Math.round((event.loaded * 100) / event.total));
      }
    },
  });
  return response.data;
};

export const deleteInfoKit = async (): Promise<void> => {
  await axios.delete('/api/info-kit');
};
